module.exports = require("joi-to-json-schema");


//////////////////
// WEBPACK FOOTER
// external "joi-to-json-schema"
// module id = 19
// module chunks = 0 1